import { useDevLogger } from '../dev-logger'
import { NAME } from './consts'

export const logger = useDevLogger(NAME)
